import type { SxProps } from '@mui/material'
import { ListItemButton as MUIListItemButton } from '@mui/material'

interface IListItemButtonProps {
  sx?: SxProps
  children: React.ReactNode
  onClick: () => void
  disabled?: boolean
}

export default function ListItemButton({ sx, children, onClick, disabled }: IListItemButtonProps) {
  return (
    <MUIListItemButton onClick={onClick} sx={sx} disabled={disabled}>
      {children}
    </MUIListItemButton>
  )
}
